import { render, staticRenderFns } from "./PageTitleMobile.vue?vue&type=template&id=530ec456&scoped=true&"
import script from "./PageTitleMobile.vue?vue&type=script&lang=js&"
export * from "./PageTitleMobile.vue?vue&type=script&lang=js&"
import style0 from "./PageTitleMobile.vue?vue&type=style&index=0&id=530ec456&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530ec456",
  null
  
)

export default component.exports